// Framework-agnostic store for notifications.
// Kept outside React so `toast()` can be called from services, interceptors and utils.

const listeners = new Set();
let state = [];
let seq = 0;

export const subscribe = (fn) => {
  listeners.add(fn);
  fn(state);
  return () => listeners.delete(fn);
};

export const getState = () => state;

const setState = (next) => {
  state = next;
  listeners.forEach((fn) => fn(state));
};

export const nextId = () => `pp-toast-${++seq}-${Date.now().toString(36)}`;

export const find = (id) => state.find((t) => t.id === id);

export const push = (toast) => setState([...state, toast]);

export const patch = (id, changes) => {
  if (!find(id)) return false;
  setState(
    state.map((t) =>
      t.id === id ? { ...t, ...(typeof changes === "function" ? changes(t) : changes) } : t
    )
  );
  return true;
};

export const patchAll = (changes) => {
  if (!state.length) return;
  setState(state.map((t) => ({ ...t, ...(typeof changes === "function" ? changes(t) : changes) })));
};

export const purge = (id) => setState(state.filter((t) => t.id !== id));

export const purgeAll = () => setState([]);
